/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CommonBookingInfoViewRestrictionsInnerLevelEnum = {
    Full: 'full',
    Partial: 'partial'
};
/**
 * @export
 */
export const CommonBookingInfoViewRestrictionsInnerReasonEnum = {
    PendingRefunds: 'pending_refunds',
    ScheduleChange: 'schedule_change',
    BookingStatusProcessing: 'booking_status_processing',
    BookingStatusRefunding: 'booking_status_refunding',
    BookingStatusRefunded: 'booking_status_refunded',
    BookingStatusChangeInProgress: 'booking_status_change_in_progress'
};
/**
 * Check if a given object implements the CommonBookingInfoViewRestrictionsInner interface.
 */
export function instanceOfCommonBookingInfoViewRestrictionsInner(value) {
    if (!('level' in value) || value['level'] === undefined)
        return false;
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
export function CommonBookingInfoViewRestrictionsInnerFromJSON(json) {
    return CommonBookingInfoViewRestrictionsInnerFromJSONTyped(json, false);
}
export function CommonBookingInfoViewRestrictionsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'level': json['level'],
        'reason': json['reason'],
    };
}
export function CommonBookingInfoViewRestrictionsInnerToJSON(json) {
    return CommonBookingInfoViewRestrictionsInnerToJSONTyped(json, false);
}
export function CommonBookingInfoViewRestrictionsInnerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'level': value['level'],
        'reason': value['reason'],
    };
}
